import { render } from "./UserTimetable.vue?vue&type=template&id=4d8321d2&scoped=true"
import script from "./UserTimetable.vue?vue&type=script&lang=js"
export * from "./UserTimetable.vue?vue&type=script&lang=js"

import "./UserTimetable.vue?vue&type=style&index=0&id=4d8321d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8321d2"]])

export default __exports__